import ApiService from './apiService';

/**
 * Service pour gérer les opérations liées aux clients
 * 
 */
class CustomerService {
    /**
     * Récupérer la liste des clients avec filtres et pagination
     * @param {Object} params Paramètres de filtrage et pagination
     * @returns {Promise} Réponse de l'API avec la liste des clients
     */
    getCustomers(params = {}) {
        return ApiService.get('/customers', params);
    }

    /**
     * Récupérer un client par son ID
     * @param {Number} id ID du client
     * @param {Object} params Paramètres additionnels (relations à charger)
     * @returns {Promise} Réponse de l'API avec les détails du client
     */
    getCustomer(id, params = {}) {
        return ApiService.get(`/customers/${id}`, params);
    }

    /**
     * Créer un nouveau client
     * @param {Object} customerData Données du client à créer
     * @returns {Promise} Réponse de l'API avec le client créé
     */
    createCustomer(customerData) {
        return ApiService.post('/customers', customerData);
    }

    /**
     * Mettre à jour un client existant
     * @param {Number} id ID du client à mettre à jour
     * @param {Object} customerData Nouvelles données du client
     * @returns {Promise} Réponse de l'API avec le client mis à jour
     */
    updateCustomer(id, customerData) {
        return ApiService.put(`/customers/${id}`, customerData);
    }

    /**
     * Supprimer un client
     * @param {Number} id ID du client à supprimer
     * @returns {Promise} Réponse de l'API
     */
    deleteCustomer(id) {
        return ApiService.delete(`/customers/${id}`);
    }

    /**
     * Récupérer les ventes d'un client
     * @param {Number} id ID du client
     * @param {Object} params Paramètres additionnels
     * @returns {Promise} Réponse de l'API avec les ventes du client
     */
    getCustomerSales(id, params = {}) {
        return ApiService.get(`/customers/${id}/sales`, params);
    }

    /**
     * Rechercher des clients
     * @param {String} query Terme de recherche
     * @param {Object} options Options additionnelles
     * @returns {Promise} Réponse de l'API avec les résultats de recherche
     */
    searchCustomers(query, options = {}) {
        return ApiService.get('/customers', {
            search: query,
            ...options
        });
    }

    /**
     * Récupérer une liste simple des clients pour les sélecteurs
     * @param {Object} params Paramètres additionnels
     * @returns {Promise} Réponse de l'API avec une liste simplifiée
     */
    getCustomersForSelect(params = {}) {
        return ApiService.get('/customers', {
            per_page: 100,
            select: 'id,name,phone,email',
            ...params
        });
    }

    /**
     * Formater un client pour l'affichage
     * @param {Object} customer Données du client
     * @returns {Object} Client formaté
     */
    formatCustomerForDisplay(customer) {
        if (!customer) return null;

        return {
            ...customer,
            formattedAddress: this.formatAddress(customer),
            salesCount: customer.sales_count || 0,
            totalSpent: customer.total_spent || 0
        };
    }

    /**
     * Formater l'adresse d'un client
     * @param {Object} customer Données du client
     * @returns {String} Adresse formatée
     */
    formatAddress(customer) {
        if (!customer) return '';

        const parts = [
            customer.address,
            customer.city,
            customer.state,
            customer.zip
        ].filter(part => part);

        return parts.join(', ');
    }
}

export default new CustomerService();